module.exports = __webpack_public_path__ + "img/1.402ba98e.jpg";